import Vue from 'vue'

const initialState = () => ({
  affiliate: {
    id: false,
    createdAt: false,
    updatedAt: false,
    status: 0,
    isTeam: false,
    tag: '',
    options: {
      paypal: false,
      ach: false
    },
    user_id: false
  }
})

export default {
  namespaced: true,
  state: initialState,
  getters: {
    isEnrolled: (state) => state.affiliate && !!state.affiliate.id,
    isTeam: (state) => state.affiliate && state.affiliate.isTeam,
    affiliateTag: (state) => state.affiliate && state.affiliate.tag,
    paymentInfo: (state) =>
      state.affiliate &&
      state.affiliate.options &&
      (state.affiliate.options.paypal || state.affiliate.options.ach)
  },
  mutations: {
    SET_AFFILIATE_INFO(state, data) {
      if (data && typeof data === 'object') {
        Object.keys(data).forEach((key) => {
          state.affiliate[key] = data[key]
        })
      }
    },
    RESET_AFFILIATE_INFO(state) {
      const initial = initialState()
      Object.keys(initial).forEach((key) => {
        state[key] = initial[key]
      })
    }
  },
  actions: {
    async getAffiliateInfo(context) {
      // context.commit('APPLY_TOKEN', null, { root: true })
      await Vue.axios
        .get(process.env.VUE_APP_ROOT_API + '/api/v1/affiliates/affiliate')
        .then(({ data }) => {
          context.commit('SET_AFFILIATE_INFO', data)
        })
        .catch((error) => {
          context.commit('SET_AFFILIATE_INFO', initialState)
        })
    }
  }
}
